// extracted by mini-css-extract-plugin
export var wordContainer = "_pw-0";